(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product_title"] && !Shopify.designMode) return;
  try {
    const iwTitleFits = new WeakSet();
  function initializeIronWomenTitle() {
    document.querySelectorAll('[data-iw-title-underline]').forEach((title) => {
      if (iwTitleFits.has(title)) return;
      iwTitleFits.add(title);
      let frame;
      function fit() {
        if (!title.isConnected || !title.clientWidth) return;
        let size = window.innerWidth < 750 ? 26 : 39;
        title.style.setProperty('--iw-title-size', size + 'px');
        const range = document.createRange();
        range.selectNodeContents(title);
        while (range.getBoundingClientRect().width > title.clientWidth && size > 22) {
          size -= 0.25;
          title.style.setProperty('--iw-title-size', size + 'px');
        }
      }
      function scheduleFit() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(fit);
      }
      fit();
      document.fonts.ready.then(scheduleFit);
      window.addEventListener('resize', scheduleFit, { passive: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeIronWomenTitle, { once: true });
  } else {
    initializeIronWomenTitle();
  }
  document.addEventListener('shopify:section:load', initializeIronWomenTitle);
  } catch(e) { console.error(e); }
})();

})();
